var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatrixRadioSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 11.375C13 12.2725 12.2725 13 11.375 13C10.4775 13 9.75 12.2725 9.75 11.375C9.75 10.4775 10.4775 9.75 11.375 9.75C12.2725 9.75 13 10.4775 13 11.375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 11.375C8.125 12.2725 7.39746 13 6.5 13C5.60254 13 4.875 12.2725 4.875 11.375C4.875 10.4775 5.60254 9.75 6.5 9.75C7.39746 9.75 8.125 10.4775 8.125 11.375Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 11.375C3.25 12.2725 2.52246 13 1.625 13C0.727537 13 0 12.2725 0 11.375C0 10.4775 0.727537 9.75 1.625 9.75C2.52246 9.75 3.25 10.4775 3.25 11.375Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.5C13 7.39746 12.2725 8.125 11.375 8.125C10.4775 8.125 9.75 7.39746 9.75 6.5C9.75 5.60254 10.4775 4.875 11.375 4.875C12.2725 4.875 13 5.60254 13 6.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 6.5C8.125 7.39746 7.39746 8.125 6.5 8.125C5.60254 8.125 4.875 7.39746 4.875 6.5C4.875 5.60254 5.60254 4.875 6.5 4.875C7.39746 4.875 8.125 5.60254 8.125 6.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 6.5C3.25 7.39746 2.52246 8.125 1.625 8.125C0.727537 8.125 0 7.39746 0 6.5C0 5.60254 0.727537 4.875 1.625 4.875C2.52246 4.875 3.25 5.60254 3.25 6.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13 1.625C13 2.52246 12.2725 3.25 11.375 3.25C10.4775 3.25 9.75 2.52246 9.75 1.625C9.75 0.727537 10.4775 0 11.375 0C12.2725 0 13 0.727537 13 1.625Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 1.625C8.125 2.52246 7.39746 3.25 6.5 3.25C5.60254 3.25 4.875 2.52246 4.875 1.625C4.875 0.727537 5.60254 0 6.5 0C7.39746 0 8.125 0.727537 8.125 1.625Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 1.625C3.25 2.52246 2.52246 3.25 1.625 3.25C0.727537 3.25 0 2.52246 0 1.625C0 0.727537 0.727537 0 1.625 0C2.52246 0 3.25 0.727537 3.25 1.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatrixRadioSelected);
export default __webpack_public_path__ + "static/media/matrix-radio-selected.47e2663c65a96d7691bbf4a42ca48d0f.svg";
export { ForwardRef as ReactComponent };